import { ArrowLeftOutlined } from "@ant-design/icons";
import { Button, Card, Col, Divider, Row, Typography } from "antd";
import React from "react";
import { useHistory } from "react-router-dom";

const { Title } = Typography;

interface Props {
  title: string;
  children: React.ReactNode;
  onBack?: () => void;
  extra?: React.ReactNode;
}

const MyProfileToolCard: React.FC<Props> = ({ title, children, onBack, extra }) => {
  const history = useHistory();

  const handleBack = () => {
    if (onBack) return onBack();
    history.push("/student-profile");
  };

  return (
    <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
      <Card style={{ width: "80%", maxWidth: 900 }}>
        <Row align="middle" gutter={[16, 16]} justify="space-between">
          <Col>
            <Button type="link" icon={<ArrowLeftOutlined />} onClick={handleBack} style={{ paddingLeft: 0 }}>
              Tilbake
            </Button>
          </Col>
          <Col flex="auto">
            <Title level={3} style={{ margin: 0 }}>
              {title}
            </Title>
          </Col>
          {extra ? <Col>{extra}</Col> : null}
        </Row>
        <Divider style={{ margin: "12px 0 24px" }} />
        {children}
      </Card>
    </div>
  );
};

export default MyProfileToolCard;
